import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0656f206"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "result-screen" }
const _hoisted_2 = { class: "result-screen__container" }
const _hoisted_3 = { class: "result-screen__img" }
const _hoisted_4 = ["srcset"]
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "result-screen__body" }
const _hoisted_7 = { class: "result-screen__video" }
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "result-screen__content" }
const _hoisted_12 = { class: "result-screen__title" }
const _hoisted_13 = { class: "result-screen__subtitle" }
const _hoisted_14 = { class: "result-screen__buttons" }
const _hoisted_15 = { class: "result-screen__button-man-left" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "result-screen__button-man-right" }, "повторить", -1))
const _hoisted_17 = ["disabled"]

import PlayIcon from "@/components/svg/PlayIcon.vue";
import { computed, inject, onMounted, ref } from "vue";
import DownloadIcon from "@/components/svg/DownloadIcon.vue";
import ShareIcon from "@/components/svg/ShareIcon.vue";
import RepeatIcon from "@/components/svg/RepeatIcon.vue";
import { copyToClipboard } from "@/utils/сopyToClipboard";
import { reachGoal } from "@/utils/reachGoal";
import CircleLoader from "@/components/CircleLoader.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'ResultScreen',
  props: {
    title: {},
    result_text: {},
    result_url: {},
    uuid: {}
  },
  emits: ["repeat"],
  setup(__props: any, { emit: __emit }) {

const player = ref<HTMLVideoElement | null>(null);
const isPlay = ref(false);
const data = inject("data");

const emit = __emit;
const props = __props;

function playPauseVideo() {
  if (!player.value) {
    return;
  }

  isPlay.value = !isPlay.value;
  player.value.play();

  if (isPlay.value) {
    player.value.play();
  } else {
    player.value.pause();
  }
}

onMounted(() => {
  if (player.value) {
    player.value.addEventListener("ended", () => {
      isPlay.value = false;
    });
  }
});

const onRepeat = () => {
  reachGoal("repeat");
  emit("repeat");
};

const copy = async () => {
  reachGoal("share");
  copyToClipboard();
};

const isVideoLoading = ref(false);

const downloadVideo = () => {
  reachGoal("download");
  isVideoLoading.value = true;
  const urlToFetch = props.result_url
    .replace(
      "s3.storage.selcloud.ru/rtk-youth/",
      "b2ac8446-6bf2-42ef-8213-8daefaf3a82b.selstorage.ru/"
    )
    .split("?")[0];
  fetch(urlToFetch)
    .then((resp) => {
      return resp.blob();
    })
    .then((asset) => {
      const blobUrl = URL.createObjectURL(asset);
      const link = document.createElement("a");

      link.href = blobUrl;
      // Set the download attribute with a filename
      link.download = `${props.uuid}.mp4`;
      // Append the link to the body
      document.body.appendChild(link);
      // Simulate a click on the link
      link.click();
      // Remove the link after downloading
      document.body.removeChild(link);
      // Release the blob URL
      window.URL.revokeObjectURL(blobUrl);
      isVideoLoading.value = false;
    })
    .catch((err) => {
      console.log(err);
      isVideoLoading.value = false;
    });
};

const validUrl = computed(() => {
  console.log(props.result_url);

  return (
    props.result_url
      .replace(
        "s3.storage.selcloud.ru/rtk-youth/",
        "b2ac8446-6bf2-42ef-8213-8daefaf3a82b.selstorage.ru/"
      )
      .split("?")[0] + "#t=1"
  );
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("picture", _hoisted_3, [
        _createElementVNode("source", {
          media: "(min-width: 780px)",
          srcset: _unref(data)['main-hero-desktop']
        }, null, 8, _hoisted_4),
        _createElementVNode("img", {
          src: _unref(data)['main-hero-mobile'],
          alt: "Главный герой"
        }, null, 8, _hoisted_5)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("video", {
            ref_key: "player",
            ref: player,
            playsinline: ""
          }, [
            _createElementVNode("source", { src: validUrl.value }, null, 8, _hoisted_8)
          ], 512),
          _createElementVNode("img", {
            class: "result-screen__mask",
            src: _unref(data)['tv-mask']
          }, null, 8, _hoisted_9),
          _createElementVNode("div", {
            class: "hoverable-overlay",
            onClick: playPauseVideo
          }),
          (!isPlay.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                id: "btnPlayPause",
                class: "play-pause play",
                title: "play",
                accesskey: "P",
                onClick: _withModifiers(playPauseVideo, ["stop"])
              }, [
                _createVNode(PlayIcon)
              ], 8, _hoisted_10))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.title), 1),
          _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.result_text), 1),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("button", {
              class: "result-screen__button-man",
              onClick: onRepeat
            }, [
              _createElementVNode("span", _hoisted_15, [
                _createVNode(RepeatIcon)
              ]),
              _hoisted_16
            ]),
            _createElementVNode("button", {
              class: "result-screen__button result-screen__download",
              disabled: isVideoLoading.value,
              onClick: downloadVideo
            }, [
              (isVideoLoading.value)
                ? (_openBlock(), _createBlock(CircleLoader, {
                    key: 0,
                    "border-width": 1,
                    style: {"width":"24px","height":"24px"}
                  }))
                : (_openBlock(), _createBlock(DownloadIcon, { key: 1 }))
            ], 8, _hoisted_17),
            _createElementVNode("button", {
              class: "result-screen__button result-screen__download",
              onClick: copy
            }, [
              _createVNode(ShareIcon)
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})